<template>
  <div class="project-list">
    <BaseContainerSpread>
      <UiPageHeader
        :title="dapLangGlobal.project"
        :description="{
          ja: 'ジャパンサーチ上で取り組まれているプロジェクトの一覧です。',
          en: 'Projects powerd by Japan Search.',
        }"
        icon="koicon/koicon-18"
      />
    </BaseContainerSpread>

    <BaseContainerSpread
      class="jps-list-card-layout generated-13"
      tag="section"
      v-if="ss.searched"
      :id="ss.state.storeId"
    >
      <div class="search-result-header">
        <div class="is-size-7-touch">
          <p>{{ lst({ ja:'{} プロジェクト', en:'{} projects' }, ss.state.result?.hit) }}</p>
        </div>
        <SearchPagination :ss="ss" />
        <div class="narrow-search">
          <SearchBoxSimple :ss="ss" :auto="true" />
        </div>
      </div>
      <Transition name="cs-project">
        <BaseLayoutGrid>
          <div v-for="proj in ss.state.result.list" :key="proj.id" class="grid-item">
            <UiDataCard type="project" :data="proj" />
          </div>
        </BaseLayoutGrid>
      </Transition>
      <SearchPagination class="footer-paginaition" :ss="ss" :autoscroll="true" />
    </BaseContainerSpread>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { lst } = useI18n()
const { searchOrganization } = useOrganization()

const ss: SearchStore<Organization> = useSearch<Database>(
  {
    keywordFields: ['keywords'],
    keywordPlaceholder: { ja: 'キーワード', en: 'Keyword' },
  },
  searchOrganization,
  {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'J'
      if (!q.filter) q.filter = {}
        q.filter.type = ['PROJECT']
      return q
    }
  }
)
await ss.restoreQuery()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.project-list {
  padding-top: 3rem;
  @include is-mobile() {
    padding-top: 1rem;
  }
  .jps-list-header {
    @include margin-full-width();
  }
}

.grid-item {
  .jps-card {
    height: 400px;
  }
}

.generated-13 {
    background-color: #fafafa;
}
</style>
